module.exports = __webpack_public_path__ + "img/grey_054.cacaa53c.png";